export default __webpack_public_path__ + "static/media/sweets-and-snacks-vegshelf.b6b84eec.png";